import axios from "axios";

import { clearAccessToken, getAccessToken } from "@/lib/auth";

export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_PREFIX = "/api";

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = String(error?.config?.url || "");
    const shouldIgnore401 =
      Boolean(error?.config?.skipAuthLogout) || requestUrl.includes("/api/auth/login");

    if (error?.response?.status === 401 && !shouldIgnore401) {
      clearAccessToken();
    }

    return Promise.reject(error);
  },
);

